export type ConflictRow = {
  /** The field as the form labels it: "Precio". */
  label: string;
  /** What this person typed, formatted the way the form shows it. */
  mine: string;
  /** What is saved now, formatted the same way. */
  theirs: string;
};

type ConflictNoticeProps = {
  rows: ConflictRow[];
  pending?: boolean;
  onKeepMine: () => void;
  onTakeTheirs: () => void;
};

/**
 * Versiones contra choques: somebody saved this record while this person was
 * editing it, and both changed the same field. What was typed stays in the
 * form; this says what is saved now and lets the person choose, knowing.
 */
export function ConflictNotice({ rows, pending = false, onKeepMine, onTakeTheirs }: ConflictNoticeProps) {
  return (
    <div role="alert" className="conflict-notice">
      <p className="conflict-title">Alguien guardó un cambio mientras editabas</p>
      <p className="conflict-sub">Lo tuyo sigue aquí, sin guardar. Esto es lo que cambió:</p>
      <dl className="conflict-rows">
        {rows.map((row) => (
          <div key={row.label} className="conflict-row">
            <dt>{row.label}</dt>
            <dd>
              <span className="conflict-side">Tú</span>
              <span className="conflict-value">{row.mine}</span>
            </dd>
            <dd>
              <span className="conflict-side">Guardado</span>
              <span className="conflict-value">{row.theirs}</span>
            </dd>
          </div>
        ))}
      </dl>
      <span className="action-pair">
        <button type="button" className="btn small" disabled={pending} onClick={onKeepMine}>
          {pending ? 'Guardando…' : 'Guardar lo mío'}
        </button>
        <button type="button" className="btn small ghost" disabled={pending} onClick={onTakeTheirs}>
          Usar lo guardado
        </button>
      </span>
    </div>
  );
}
